export default __webpack_public_path__ + "static/media/boat.675af2eb.png";